// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterBackImages_root__2Ynck","title":"AfterBackImages_title__3OY3B","images":"AfterBackImages_images__2C0zz"};